import AddRoundedIcon from '@mui/icons-material/AddRounded'
import { Grid } from '@mui/material'
import { ButtonSecondary } from 'components/ButtonSecondary'
import React, { useEffect, useState } from 'react'
import {
  Control,
  FieldValues,
  Path,
  PathValue,
  useFieldArray,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { FieldArrayPath } from 'react-hook-form/dist/types/path'
import { AddressItem } from 'pages/SocioeducationMeasureEdit/components/AddressList/components/AddressItem'

interface AddressListProps<
  TFieldValues extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues>,
> {
  control: Control<TFieldValues>
  watch: UseFormWatch<TFieldValues>
  setValue: UseFormSetValue<TFieldValues>
  fieldArrayName: TFieldArrayName
  initialValuesFieldName: Path<TFieldValues>
  disabled?: boolean
  initialValues: PathValue<TFieldValues, Path<TFieldValues>>
}

export const AddressList = <
  TFieldValues extends FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues>,
>({
  control,
  setValue,
  watch,
  initialValuesFieldName,
  fieldArrayName,
  disabled,
  initialValues,
}: AddressListProps<TFieldValues, TFieldArrayName>) => {
  const {
    fields: addressesFields,
    append: handleAddAddress,
    remove: handleRemoveAddress,
  } = useFieldArray<TFieldValues>({
    control,
    name: fieldArrayName,
  })

  const [disableAddButton, setDisableAddButton] = useState<boolean>(false)

  const addressesValues = watch(initialValuesFieldName)

  useEffect(() => {
    if (addressesValues && !addressesValues.length) {
      setValue(initialValuesFieldName, initialValues, { shouldDirty: false })
    }

    if (addressesValues && addressesValues.length > 1) {
      const hasPrincipal: boolean = addressesValues.find((item: any) => item.enderecoPrincipal)
      if (!hasPrincipal) {
        setValue(
          `${fieldArrayName}.0.enderecoPrincipal` as Path<TFieldValues>,
          true as PathValue<TFieldValues, Path<TFieldValues>>,
          { shouldDirty: true },
        )
      }
    }
  }, [addressesValues])

  return (
    <Grid container item xs={12} spacing={2}>
      {addressesFields.map((_, i) => (
        <Grid key={i} item xs={12}>
          <AddressItem
            index={i}
            control={control}
            watch={watch}
            setValue={setValue}
            name={initialValuesFieldName}
            listValues={addressesValues}
            onRemove={handleRemoveAddress}
            disabled={disabled}
          />
        </Grid>
      ))}
      <Grid item xs={12}>
        <ButtonSecondary
          maxWidth={150}
          startIcon={<AddRoundedIcon />}
          label='Endereço'
          onClick={() => handleAddAddress(initialValues)}
          disabled={disabled}
        />
      </Grid>
    </Grid>
  )
}
